import { render, staticRenderFns } from "./InternetSpeed.vue?vue&type=template&id=acd65726&"
import script from "./InternetSpeed.vue?vue&type=script&lang=js&"
export * from "./InternetSpeed.vue?vue&type=script&lang=js&"
import style0 from "./InternetSpeed.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports